@if (sfContactId) {
  <div class="machines-container mt-2" [formGroup]="form">
    @for (accountGroup of machinesByAccount; track accountGroup) {
      <div class="account-group mb-4">
        <h5 class="account-name mb-2">{{ accountGroup.accountName }}</h5>
        <div class="machines-list">
          @for (machine of accountGroup.machines; track machine) {
            <div class="machine-item form-check mb-2">
              <input
                #machineCheckbox
                class="form-check-input"
                type="checkbox"
                [id]="'machine-' + machine.id"
                [checked]="isMachineSelected(machine.id || '')"
                (change)="onMachineSelection(machine, machineCheckbox.checked)"
                [ngClass]="isLight ? 'light' : 'dark'"
                [style.opacity]="!isCurrentUserAdmin ? '0.6' : '1'"
                [style.cursor]="!isCurrentUserAdmin ? 'not-allowed' : 'pointer'"
                />
              <label
                class="form-check-label"
                [for]="'machine-' + machine.id"
                [appTooltip]="'SN: ' + machine.serialNumber + ' | Account: ' + accountGroup.accountName"
                [style.cursor]="!isCurrentUserAdmin ? 'not-allowed' : 'pointer'"
                >
                {{ machine.assetName || 'N/A' }}
              </label>
            </div>
          }
        </div>
      </div>
    }
    @if (machinesByAccount.length === 0 && isMachinesLoaded) {
      <div class="alert alert-warning mt-2">
        {{ 'USER_FORM.NO_MACHINES' | translate }}
      </div>
    }
  </div>
}
